import { render, staticRenderFns } from "./RawMaterialView.vue?vue&type=template&id=58fb013f&scoped=true&"
import script from "./RawMaterialView.vue?vue&type=script&lang=js&"
export * from "./RawMaterialView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb013f",
  null
  
)

export default component.exports